const A = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAElSURBVFiF7ZdhbsMgDIWfp95r9GSwk0FP9vbHjVKECdDQMq1PiiLZCH8xBhPgo0dJyUjSA3CTYiYR+TkcRTJyvnweVzIIDyDcyfU5W/f5ryKyzX8xBicRuU6AAMlQsn/NCDYiKyMoreM7QBzm7Zqill+amcXKkn2ZjHSBkHTWgbQbE58udJJeA8VKEPN0zPzOmKPqbwKpwRxBng5SCtoKUQMZqRGPxx4UkJ051a81ZJ6sFYUGf0Jnw1xm+3ZlRNv2dnXQJYjqK16yWvU3M6IZ+DZ8+91y2196TgdRhQZ7QmexjoDkAVzB3gXRDaLp3oLoUjn1PdWtlynWZUBGamSTiCQat/KXggBA01/bAMhN3+6oiw7KNY/km345LRg/CSA2Q/x7/QKWtiT4TZH0vwAAAABJRU5ErkJggg==";
export {
  A as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/assets/money.png.js
// module id = 1144
// module chunks = 41